import config from "../config/config.json";
import { headers } from "../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../APIHelpers/Responses";

export const globalFormManagementServices = {
  //Global Form
  addNewGlobalForm,
  addNewGlobalFormWithFile,
  duplicateGlobalForm,
  updateGlobalForm,
  addUpdateGlobalFormFields,
  deleteGlobalForm,
  softDeleteRestoreGlobalForm,
  getGlobalForm,
  getGlobalFormByCategory,
  getGlobalFormBasedOnFieldKey,
  getGlobalFormFields,
  getHeighestVersionFormHistory,
  getGlobalFormAuditTrials,

  //Global Form Field Group Library
  addNewGlobalFormFieldLibrary,
  updateGlobalFormLibraryField,
  addUpdateGlobalFormFieldLibrary,
  addNewFieldsGlobalFormFieldLibrary,
  deleteGlobalFormFieldLibrary,
  getGlobalFormFieldGroupLibrary,
  findGlobalFormFieldGroupLibrary,

  //Global Form Field Group
  addNewGlobalFormFieldGroup,
  updateGlobalFormFieldGroup,
  deleteGlobalFormField,
  softDeleteRestoreGlobalFormFieldGroup,
  getGlobalFormFieldGroup,
  getGlobalFormFieldGroupAuditTrials,
  getHeighestVersionFormFieldGroupHistory,
};

// Get Global Form
async function getGlobalForm(status, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getGlobalForm/${status}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getGlobalForm/${status}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Add New Global Form
async function addNewGlobalForm(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewGlobalForm`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Add New Global Form With File
async function addNewGlobalFormWithFile(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewGlobalFormWithFile`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}


// Duplicate Global Form
async function duplicateGlobalForm(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}duplicateGlobalForm`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Global Form
async function updateGlobalForm(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateGlobalForm`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Update Global Form Fields
async function addUpdateGlobalFormFields(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addUpdateGlobalFormFields`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Soft Delete & Restore Global Form
async function softDeleteRestoreGlobalForm(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreGlobalForm`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Delete Global Form
async function deleteGlobalForm(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteGlobalForm`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Get Global Form Audit Trial
async function getGlobalFormAuditTrials(formId) {
  let response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getGlobalFormAuditTrials/${formId}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  const data = await response.json();
  return data;
}

// Get Global Form Heighest Version
async function getHeighestVersionFormHistory(formId) {
  let response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getHeighestVersionFormHistory/${formId}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  const data = await response.json();
  return data;
}

// Get Global Form Fields
async function getGlobalFormFields(formId) {
  let response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getGlobalFormFields/${formId}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  const data = await response.json();
  return data;
}

// Get Global Form Based on Category
async function getGlobalFormByCategory(category) {
  let response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getGlobalFormByCategory/${category}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  const data = await response.json();
  return data;
}

// Get Global Form Based on Form Field
async function getGlobalFormBasedOnFieldKey(category, formType, formId, fieldName) {
  let response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getGlobalFormBasedOnFieldKey/${category}/${formType}/${formId}/${fieldName}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  const data = await response.json();
  return data;
}

// Add New Global Form Field Group
async function addNewGlobalFormFieldGroup(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewGlobalFormFieldGroup`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Global Form Field Group
async function updateGlobalFormFieldGroup(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateGlobalFormFieldGroup`,
    headersWithAuth("Put", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Delete Global Form Field Group
async function deleteGlobalFormField(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteGlobalFormField`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Soft Delete & Restore Global Form Field Group
async function softDeleteRestoreGlobalFormFieldGroup(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreGlobalFormFieldGroup`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Get Global Field Group Form
async function getGlobalFormFieldGroup(status, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getGlobalFormFieldGroup/${status}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getGlobalFormFieldGroup/${status}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Get Global Form Field Group Audit Trial
async function getGlobalFormFieldGroupAuditTrials(categoryId) {
  let response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getGlobalFormFieldGroupAuditTrials/${categoryId}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  const data = await response.json();
  return data;
}

// Get Global Form Field Group Heighest Version
async function getHeighestVersionFormFieldGroupHistory(categoryId) {
  let response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getHeighestVersionFormFieldGroupHistory/${categoryId}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  const data = await response.json();
  return data;
}

// Add Global Form Field Group Library
async function addNewGlobalFormFieldLibrary(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewGlobalFormFieldLibrary`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Update Global Form Field Group Library
async function updateGlobalFormLibraryField(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateGlobalFormLibraryField`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Add Update Global Form Field Group Library
async function addUpdateGlobalFormFieldLibrary(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addUpdateGlobalFormFieldLibrary`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Add New Fiels in Global Form Field Library
async function addNewFieldsGlobalFormFieldLibrary(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewFieldsGlobalFormFieldLibrary`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Delete Global Form Field Group Library
async function deleteGlobalFormFieldLibrary(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteGlobalFormFieldLibrary`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Get Global Form Field Group Library
async function getGlobalFormFieldGroupLibrary() {
  let response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getGlobalFormFieldGroupLibrary`,
      headersWithAuthWithoutBody("GET", headers)
    );
  const data = await response.json();
  return data;
}

// Get Single Global Form Field Group Library
async function findGlobalFormFieldGroupLibrary(categoryId) {
  let response = await fetch(
      `${config.API_URL_USER_ONBOARDING}findGlobalFormFieldGroupLibrary/${categoryId}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  const data = await response.json();
  return data;
}